import { useEffect } from 'react';
import { analytics } from '../../../firebase';
import { logEvent } from 'firebase/analytics';
import TeamLinkPrivacy from './privacy';

export default function TeamLinkLegal() {
  const pathname = window.location.pathname;
  const isPrivacyOnly = pathname.includes('/privacy');

  useEffect(() => {
    logEvent(analytics, 'page_view', {
      page_title: isPrivacyOnly ? 'Privacy Policy - TeamLink' : 'Legal - TeamLink',
      page_location: window.location.href,
      page_path: window.location.pathname
    });
    window.scrollTo(0, 0);
  }, [isPrivacyOnly]);

  if (isPrivacyOnly) {
    return <TeamLinkPrivacy />;
  }

  const primaryColor = '#2563eb';
  const backgroundColor = '#f8f9fa';
  const darkTextColor = '#333333';
  const lightTextColor = '#666666';
  const borderColor = '#e9ecef';

  const sectionHeaderStyle = {
    fontSize: '1.25rem',
    fontWeight: '600',
    color: '#1a1a1a',
    marginBottom: '16px',
    paddingBottom: '8px',
    borderBottom: `1px solid ${borderColor}`
  };

  const subHeaderStyle = {
    fontSize: '1.1rem',
    fontWeight: '600',
    color: '#1a1a1a',
    marginBottom: '12px',
    marginTop: '24px'
  };

  const cardStyle = {
    padding: '24px',
    backgroundColor: backgroundColor,
    borderRadius: '8px',
    border: `1px solid ${borderColor}`,
    marginBottom: '32px'
  };

  const headingStyle = {
    fontWeight: '300',
    color: '#1a1a1a'
  };

  return (
    <div style={{
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      backgroundColor: '#ffffff',
      color: darkTextColor,
      lineHeight: '1.6',
      fontSize: '16px'
    }}>
      {/* Header */}
      <div style={{
        backgroundColor: backgroundColor,
        padding: '40px 20px',
        textAlign: 'center',
        borderBottom: `1px solid ${borderColor}`
      }}>
        <img
          src="/apps/teamlink/logo.png"
          alt="TeamLink Logo"
          style={{
            width: '64px',
            height: '64px',
            marginBottom: '20px',
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        />
        <h1 style={{ ...headingStyle, fontSize: '2.5rem', margin: '0 0 8px 0' }}>
          Legal Documentation
        </h1>
        <p style={{
          fontSize: '18px',
          color: primaryColor,
          margin: '0 0 8px 0',
          fontWeight: '500'
        }}>
          TeamLink - Sync, Share and Search Bookmarks
        </p>
        <p style={{
          fontSize: '14px',
          color: lightTextColor,
          margin: '0'
        }}>
          Effective Date: September 28, 2021
        </p>
      </div>

      {/* Content */}
      <div style={{
        maxWidth: '720px',
        margin: '0 auto',
        padding: '32px 20px'
      }}>
        
        <div style={{ ...cardStyle, marginBottom: '48px', textAlign: 'center', backgroundColor: 'rgba(37, 99, 235, 0.05)' }}>
          <p style={{ margin: 0, fontWeight: '500', color: primaryColor }}>
            PLEASE READ THESE TERMS CAREFULLY. BY USING TEAMLINK, YOU ARE BOUND BY THE TERMS OF USE AND THE PRIVACY POLICY CONTAINED HEREIN.
          </p>
        </div>

        {/* TERMS OF USE */}
        <section id="terms" style={{ marginBottom: '64px' }}>
          <h2 style={{ ...headingStyle, ...sectionHeaderStyle, fontSize: '1.75rem' }}>Terms of Use</h2>
          
          <h3 style={subHeaderStyle}>1. License Grant</h3>
          <p>Tattva Dynamics grants you a non-exclusive, non-transferable, limited license to use the TeamLink browser extension and associated services for personal or professional bookmark management.</p>

          <h3 style={subHeaderStyle}>2. User Responsibilities</h3>
          <p>You are responsible for maintaining the confidentiality of your account and for all activities that occur under your account. You agree to use the service only for lawful purposes.</p>

          <h3 style={subHeaderStyle}>3. Intellectual Property</h3>
          <p>All content, features, and functionality of TeamLink are and will remain the exclusive property of Tattva Dynamics and its licensors.</p>

          <h3 style={subHeaderStyle}>4. Limitation of Liability</h3>
          <p>Tattva Dynamics shall not be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses.</p>
        </section>

        {/* PRIVACY POLICY LINK */}
        <section id="privacy-link" style={{ marginBottom: '64px' }}>
          <h2 style={{ ...headingStyle, ...sectionHeaderStyle }}>Privacy Policy</h2>
          <p>Our Privacy Policy governs the collection, use, and disclosure of your personal information. You can find the full text of our Privacy Policy <a href="/teamlink/privacy" style={{ color: primaryColor }}>here</a>.</p>
        </section>

        {/* Contact Section */}
        <div style={cardStyle}>
          <h2 style={{ ...headingStyle, ...sectionHeaderStyle, borderBottom: 'none', marginBottom: '8px' }}>
            Contact Us
          </h2>
          <p style={{ color: '#495057', margin: '0 0 16px 0' }}>
            If you have any questions about these legal terms, please contact us:
          </p>
          <div>
            <strong style={{ color: '#1a1a1a' }}>Email:</strong>
            <a href="mailto:support@tattvadynamics.com" style={{ color: primaryColor, textDecoration: 'none', marginLeft: '8px', fontWeight: '500' }}>
              support@tattvadynamics.com
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{
        textAlign: 'center',
        padding: '24px 20px',
        backgroundColor: backgroundColor,
        borderTop: `1px solid ${borderColor}`,
        color: lightTextColor,
        fontSize: '14px'
      }}>
        <p style={{ margin: '0' }}>
          © 2026 Tattva Dynamics. All rights reserved.
        </p>
      </div>
    </div>
  );
}
